/* A Leading Role - Front Row nudge in the cart drawer.
 *
 * Additive on purpose: alr.js owns #modal-bag and re-renders #mbag-root on
 * every cart change, so this watches that node and re-inserts a single line
 * under the shipping bar rather than editing alr.js. Built with DOM calls,
 * not innerHTML, so nothing here can be injected.
 *
 * Hidden when: the shopper is already a Front Row member (layout/theme.liquid
 * writes #c-frontrow-data from customer.tags), or the membership itself is
 * already in the bag, or the shopper dismissed it this session.
 *
 * Gold is decorative only - readable text is maroon or the muted brown, as in
 * the welcome pop-up (alr-welcome-frontrow.js).
 */
(function () {
  var JOIN = '/products/front-row-membership';
  var MAROON = '#5B1220';
  var GOLD = '#C9A227';
  var MUTED = '#5A452F';
  var KEY = 'alr_fr_cart_dismissed';

  var cfg = { member: false, variant: 0 };
  try {
    var raw = document.getElementById('c-frontrow-data');
    if (raw) cfg = JSON.parse(raw.textContent) || cfg;
  } catch (err) {}

  if (cfg.member) return;

  var dismissed = false;
  try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (err) {}
  if (dismissed) return;

  function styles() {
    if (document.getElementById('fr-cart-style')) return;
    var s = document.createElement('style');
    s.id = 'fr-cart-style';
    s.textContent = [
      '.cart-fr{position:relative;margin:14px 0 4px;padding:12px 34px 12px 14px;border:1px solid rgba(201,162,39,.55);',
      'border-radius:10px;background:rgba(255,248,232,.7);text-align:left}',
      '.cart-fr .fr-k{display:block;font-size:.58rem;letter-spacing:.16em;text-transform:uppercase;font-weight:600;color:' + MAROON + ';margin-bottom:4px}',
      '.cart-fr .fr-k b{color:' + GOLD + ';font-weight:400;margin-right:6px}',
      '.cart-fr .fr-t{margin:0;font-size:.8rem;line-height:1.5;color:' + MUTED + '}',
      '.cart-fr .fr-t a{color:' + MAROON + ';text-decoration:underline;text-underline-offset:2px;white-space:nowrap}',
      '.cart-fr .fr-x{position:absolute;top:6px;right:8px;appearance:none;border:0;background:none;font:inherit;font-size:16px;line-height:1;',
      'color:' + MUTED + ';cursor:pointer;padding:4px 6px;opacity:.7}',
      '.cart-fr .fr-x:hover{opacity:1;color:' + MAROON + '}'
    ].join('');
    document.head.appendChild(s);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function membershipInBag(root) {
    if (!cfg.variant) return false;
    var links = root.querySelectorAll('.cart-line a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href').indexOf('front-row-membership') !== -1) return true;
    }
    return false;
  }

  function node() {
    var box = el('div', 'cart-fr');

    var k = el('span', 'fr-k');
    var star = el('b');
    star.innerHTML = '&#10022;';
    k.appendChild(star);
    k.appendChild(document.createTextNode('Front Row'));
    box.appendChild(k);

    var t = el('p', 'fr-t');
    t.appendChild(document.createTextNode(
      'Members ship free on every order and never pay the restocking fee. $99 a year. '
    ));
    var a = el('a', null, 'See Front Row');
    a.setAttribute('href', JOIN);
    t.appendChild(a);
    box.appendChild(t);

    var x = el('button', 'fr-x');
    x.setAttribute('type', 'button');
    x.setAttribute('aria-label', 'Dismiss');
    x.innerHTML = '&times;';
    x.addEventListener('click', function () {
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      dismissed = true;
      box.parentNode && box.parentNode.removeChild(box);
    });
    box.appendChild(x);
    return box;
  }

  function place(root) {
    if (dismissed || !root) return;
    var existing = root.querySelector('.cart-fr');
    var lines = root.querySelector('.cart-lines');
    var empty = !lines || !lines.querySelector('.cart-line');
    if (empty || membershipInBag(root)) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }
    if (existing) return;
    styles();
    var bar = root.querySelector('.cart-shipbar');
    var n = node();
    if (bar && bar.nextSibling) root.insertBefore(n, bar.nextSibling);
    else if (bar) root.appendChild(n);
    else root.insertBefore(n, lines);
  }

  function watch() {
    var root = document.getElementById('mbag-root');
    if (!root) return false;
    place(root);
    var mo = new MutationObserver(function () { place(root); });
    mo.observe(root, { childList: true });
    return true;
  }

  function start() {
    if (watch()) return;
    // alr.js may build the drawer after us; wait for it once.
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (watch() || tries > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
